import React from "react";
import { useTranslation } from "react-i18next";
import Button from "components/button/Button";
import { Modal } from "components/modal";

interface HelpModalProps {
  isOpen: boolean;
  onClose: () => void;
  imageUrl: string;
  title?: string;
  description?: string;
}

const HelpModal: React.FC<HelpModalProps> = ({
  isOpen,
  onClose,
  imageUrl,
  title,
  description,
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      showCloseButton={true}
      maxWidth={"max-w-4xl"}
      className="p-6 lg:p-8"
    >
      <div className="space-y-4">
        {/* Header */}
        <div className="text-center">
          {title && (
            <h4 className="mb-3 text-lg font-semibold text-gray-800 dark:text-white/90 md:text-xl">
              {title}
            </h4>
          )}

          {description && (
            <p className="sm:text-md text-sm leading-6 text-gray-700 dark:text-gray-400">
              {description}
            </p>
          )}
        </div>

        {/* Image */}
        <div className="relative overflow-hidden rounded-xl border border-gray-200 dark:border-gray-700">
          <img
            src={imageUrl}
            alt={title || "Help image"}
            className="h-auto max-h-[90vh] w-full bg-gray-50 object-contain dark:bg-gray-800"
            loading="lazy"
          />
        </div>

        {/* Footer */}
        <div className="mt-6 flex w-full items-center justify-center">
          <Button
            size="sm"
            variant="outline"
            onClick={onClose}
            className="min-w-[120px]"
          >
            {t("buttons.close")}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default HelpModal;
